/* eslint-disable import/no-unresolved */
/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { BsFiletypeXml } from 'react-icons/bs';
import DownloadIcon from '@mui/icons-material/Download';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import SEBicon from '../../../assets/img/SEBicon.png';
import {
  Toolbar,
  Tooltip,
  IconButton,
  Typography,
  OutlinedInput,
  InputAdornment,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
// component
import { SearchType } from 'src/components/common/SearchType';
import { useLocation } from 'react-router-dom';
import Iconify from '../../../components/Iconify';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { monthsData } from '../../../utils/commonFunc';
import BookEditInvoice from '../../../pages/dashboard/invoices/InvoicesModal/BookEditInvoice';

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: 96,
  height: 'auto',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1, 1, 1, 3),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
  },
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  [theme.breakpoints.down('sm')]: {
    '&.Mui-focused': { width: '100%' },
  },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`,
  },
}));

// ----------------------------------------------------------------------

ListToolbar.propTypes = {
  numSelected: PropTypes.number,
  searchQuery: PropTypes.string,
  onFilter: PropTypes.func,
  onDelete: PropTypes.func,
  salarySelected: PropTypes.number,
  onMoveSalary: PropTypes.func,
  onUndoSalary: PropTypes.func,
  onDeleteSalary: PropTypes.func,
  selectedSalaryNestedTabValue: PropTypes.string,
  selectedTFNestedTabValue: PropTypes.string,
  isAddFileBtn: PropTypes.string,
  isAddCreateBtn: PropTypes.string,
  onAddCreateBtn: PropTypes.func,
  onAddTaxFile: PropTypes.func,
  settoggleModal: PropTypes.func,
  setIsToggleXml: PropTypes.func,
  setSebToggleXml: PropTypes.func,
  isAddCreateFile: PropTypes.bool,
  isSyncBtn: PropTypes.bool,
  handleOnSync: PropTypes.func,
  selectedInvoices: PropTypes.array,
  onBookingSuccess: PropTypes.func,
};

export default function ListToolbar({
  numSelected,
  searchQuery,
  onFilter,
  onDelete,
  handleCreateSalary,
  selectedTabValue,
  onSendEmail,
  hideDeleteButton,
  hideEmailButton,
  salarySelected,
  onMoveSalary,
  onUndoSalary,
  onDeleteSalary,
  selectedSalaryNestedTabValue,
  selectedTFNestedTabValue,
  isAddFileBtn,
  isAddCreateBtn,
  onAddCreateBtn,
  onAddTaxFile,
  settoggleModal,
  setSebToggleXml,
  dropOptions,
  searchDropValue,
  setSearchDropValue,
  setIsToggleXml,
  isAddCreateFile,
  isSyncBtn,
  handleOnSync,
  syncSelected,
  getYears,
  handleChangeDate,
  year,
  month,
  handleClearFilter,
  onDownload,
  handleBookedButtonClick,
  selectedInvoices,
  onBookingSuccess,
  additionalFilters,
}) {
  const location = useLocation();
  
  const [showBookInvoiceModal, setShowBookInvoiceModal] = useState(false);

  const handleBookInvoicesClick = () => {
    if (!selectedInvoices || selectedInvoices.length === 0) {
      toast.error('No invoices selected');
      return;
    }

    // Check if any selected invoice is already booked
    const unbookedInvoices = selectedInvoices.filter(invoice => !invoice.isBooked);
    
    if (unbookedInvoices.length === 0) {
      toast.error('All selected invoices are already booked');
      return;
    }

    setShowBookInvoiceModal(true);
  };

  const handleBookingSuccess = () => {
    setShowBookInvoiceModal(false);
    if (onBookingSuccess) {
      onBookingSuccess();
    }
  };

  const handleCloseBookModal = () => {
    setShowBookInvoiceModal(false);
  };
   
  return (
    <RootStyle
      sx={{
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter',
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <div className="d-flex align-items-center flex-wrap" style={{ gap: '8px' }}>
          { selectedTFNestedTabValue !== '4' ?
          <SearchStyle
            className="search__bar"
            value={searchQuery || ''}
            onChange={onFilter}
            placeholder="Search..."
            startAdornment={
              <InputAdornment position="start">
                <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
              </InputAdornment>
            }
          />:null}

          {!isAddCreateFile && !isAddFileBtn &&
           (location.pathname !== '/dashboard/notifications' && location.pathname !== '/dashboard/view-logs' && (
            <SearchType
              dropOptions={dropOptions}
              searchDropValue={searchDropValue}
              setSearchDropValue={setSearchDropValue}
            />
          ))}
          {isAddCreateFile &&(
            <SearchType
              dropOptions={dropOptions}
              searchDropValue={searchDropValue}
              setSearchDropValue={setSearchDropValue}
            />
          )}

          {additionalFilters}

          {isAddCreateBtn || selectedTFNestedTabValue === '4' ? (
            <div className="ml-4 d-flex align-items-center">
              <FormControl sx={{ minWidth: 120 }} size="small" style={{ marginTop: '7px' }}>
                <InputLabel id="demo-select-small-label">Months</InputLabel>
                <Select
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  value={month}
                  label="Months"
                  onChange={(e) => handleChangeDate(e, 'month')}
                >
                  <option disabled value="">
                    {'Select month'}
                  </option>
                  {monthsData?.map((item) => (
                    <MenuItem key={item?.id} value={item?.id}>
                      {item?.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl sx={{ minWidth: 120 }} size="small" style={{ marginTop: '7px', marginLeft: "4px" }}>
                <InputLabel id="demo-select-small-label">Year</InputLabel>
                <Select
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  value={year}
                  onChange={(e) => handleChangeDate(e, 'year')}
                >
                  {getYears &&
                    getYears.map((item) => (
                      <MenuItem key={item} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              <Button variant="outlined" className="ml-2" onClick={() => handleClearFilter()}>
                Clear Filters{' '}
              </Button>
            </div>
          ):null}
        </div>
      )}

      {numSelected > 0 ? (
        <div>
          {!hideEmailButton && (
            <Tooltip title="Send Email">
              <IconButton onClick={() => onSendEmail()}>
                <Iconify sx={{ mt: 1, width: 27, height: 27 }} icon="material-symbols:outgoing-mail" />
              </IconButton>
            </Tooltip>
          )}
          {!hideDeleteButton && (
            <Tooltip title={selectedTabValue === "1" || selectedTabValue === "2" ? "Create Salary": selectedTabValue === "5" ? "Delete" : ""}>
              {selectedTabValue === '1'|| selectedTabValue === "2" ? (<Button variant="primary" style={{border:"1px solid #c6c6c6"}} onClick={() => handleCreateSalary()}>
                <AddCircleOutlineIcon icon="eva:trash-2-fill" /> <span className='mx-2'> Create Salary</span>
              </Button>): selectedTabValue === "5" ? (<IconButton onClick={() => onDelete()}>
                <Iconify icon="eva:trash-2-fill" />
              </IconButton>) : ""}
              
              
            </Tooltip>
          )}

          {selectedTabValue === "1" && (
            <Tooltip title="Book Invoices">
              <Button variant="primary" style={{border:"1px solid #c6c6c6", marginLeft: "8px"}} onClick={() => handleBookInvoicesClick()}>
                <AddCircleOutlineIcon /> <span className='mx-2'> Book Invoices</span>
              </Button>
            </Tooltip>
          )}
        </div>
      ) : (
        ''
      )}

      {/* Book Invoice Modal */}
      {showBookInvoiceModal && (
        <BookEditInvoice
          selectedRow={selectedInvoices && selectedInvoices.length > 0 ? selectedInvoices[0] : null}
          selectedRowInvoiceNumber={selectedInvoices?.map(invoice => invoice.invoiceNumber)}
          onBookingSuccess={handleBookingSuccess}
          onClose={handleCloseBookModal}
          autoShow={true}
          selectedInvoices={selectedInvoices}
        />
      )}

      {salarySelected > 0 ? (
        <div>
          {(selectedSalaryNestedTabValue === '2' || selectedSalaryNestedTabValue === '3') && (
            <>            
               <Tooltip title="Generate PDF">
                <Button onClick={() => settoggleModal(true)}>
                  <PictureAsPdfIcon />
                </Button>
              </Tooltip>

              <Tooltip title="Generate SEB XML">
                <Button onClick={() => setSebToggleXml(true)}>
                   <img src={SEBicon} alt="SEB" style={{ width: 25, height: 50 }} />
                </Button>
              </Tooltip>

              <Tooltip title="Generate XML">
                <Button onClick={() => setIsToggleXml(true)}>
                  <BsFiletypeXml style={{ fontSize: 20 }} />
                </Button>
              </Tooltip>
            </>
          )}

          {!hideDeleteButton && selectedSalaryNestedTabValue !== '1' && (
            <Tooltip
              title={
                selectedSalaryNestedTabValue === '3'
                  ? 'Move to Checked'
                  : selectedSalaryNestedTabValue === '2'
                  ? 'Move to Unpaid'
                  : ''
              }
            >
              <IconButton onClick={() => onUndoSalary()}>
                <Iconify icon="material-symbols:undo" />
              </IconButton>
            </Tooltip>
          )}

          {!hideEmailButton && (
            <Tooltip
              title={
                selectedSalaryNestedTabValue === '1'
                  ? 'Move to checked'
                  : selectedSalaryNestedTabValue === '2'
                  ? 'Revolut Bank File'
                  : 'Revolut Bank File'
              }
            >
              <IconButton onClick={() => onMoveSalary()}>
                <Iconify
                  sx={{ mt: 1, width: 27, height: 27 }}
                  icon="fluent-mdl2:generate"
                  style={{ height: '21px', marginBottom: '3px', marginRight: '5px' }}
                />
              </IconButton>
            </Tooltip>
          )}
          {!hideDeleteButton && selectedSalaryNestedTabValue === '1' && (
            <Tooltip title="Delete">
              <IconButton onClick={() => onDeleteSalary()}>
                <Iconify icon="eva:trash-2-fill" />
              </IconButton>
            </Tooltip>
          )}
        </div>
      ) : (
        <>
          {isAddCreateBtn && (
            <Button variant="outlined" onClick={() => onAddCreateBtn()}>
              {'Create Salary'}
            </Button>
          )}
        </>
      )}

      {(isAddFileBtn && !selectedSalaryNestedTabValue) && selectedTFNestedTabValue !== '4' ? (
        <Button variant="outlined" onClick={() => onAddTaxFile()}>
          {'Create tax file'}
        </Button>
      ) : (
        ''
      )}

      {selectedTFNestedTabValue === '4' &&(
        <>
            <Button
          variant="outlined"
          onClick={()=> onDownload()}
          disabled={!month || !year} 
        >
          <DownloadIcon/>
        </Button>
        </>
      )}

      {isSyncBtn ? (
        <Button variant="outlined" disabled={!syncSelected.length > 0} onClick={() => handleOnSync()}>
          {'Sync to Fortnox'}
        </Button>
      ) : (
        ''
      )}
    </RootStyle>
  );
}
